import { observer } from 'mobx-react-lite';
import { TodayTimeCell } from './today-time-cell';
import { ScheduledEventQueueRowData } from '../../../socket/stream-types';
import columnDefinitionEnum from '../../../queues/column-definition.enum';

export const TargetOnSceneTimeCell = observer(function TargetOnSceneTimeCell({
    data,
}: {
    data: ScheduledEventQueueRowData;
}): React.ReactElement {
    return (
        <TodayTimeCell
            dateStr={data.targetOnSceneTime}
            columnDefinitionName={columnDefinitionEnum.TARGET_ON_SCENE_TIME.name}
        />
    );
});
